<template>
	<div v-if="detailData" class="detailmessage-class">
		<div class="detailmessage-header">
			{{detailData.title}}
		</div>
		<el-scrollbar wrapClass="yf-container" viewClass="yf-content" wrapStyle=""
			viewStyle="height:500px;" :native="false" :noresize="true" tag="div">
			<div class="detailmessage-center" v-html="detailData.content">
		</div>
		</el-scrollbar>
		
		
		<div class="detailmessage-bottom">
				<div class="wei">豆包泛知道</div>
			<br />
				<div class="wei">{{detailData.created_time}}</div>
		</div>
	</div>
</template>
<script>
	import {
		mapMutations,
		mapState,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
detailData:''
			}
		},
		created() {
			this.getInfo()
			console.log(252,)
		},

		methods: {
			...mapActions('message', ['messageInfo','messageReady','messageUnreadyNumber']),

			async getInfo(){
				let obj={}
				obj.message_id =this.$route.query.id
			 	let res=await this.messageInfo(obj)
				this.detailData=res
				console.log(7569,res);
				await this.messageReady(obj)
				this.messageUnreadyNumber()
			}
		}
	}
</script>
<style lang="less" scoped>
	.detailmessage-header {
		width: 925px;
		height: 50px;
		text-align: center;
		line-height: 50px;
		border-radius: 4px;
		border-bottom: 3px solid #c8e3ff;
		padding: 10px;
		font-weight: 650;
		
	}
	.detailmessage-center{
		width: 925px;
		// height: 500px;
		box-sizing: border-box;
		padding: 40px;
		overflow: auto;
		/deep/ img{
			max-width: 825px;
		}
	}
	.detailmessage-bottom{
		width: 925px;
		height: 50px;
		.wei{
			float: right;
			width: 150px;
			text-align: center;
		}
		
	}
</style>
